import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana72Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
  <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">

  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("14"))}
    d="M368.117 526.358V501.393H293.224L270.75 553.821C268.753 581.783 289.891 580.451 300.709 576.29L368.117 526.358Z" 
    fill={getFillByLot(14, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  
  <rect width="1221" height="921" fill="url(#pattern0_1465_19735)"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("14"))}    
    d="M202.767 549.496H229.076V599.608H182.722L202.767 549.496Z" 
    fill={getFillByLot(14, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("15"))}    
    d="M167.69 634.686L182.723 599.607H212.79V647.214H171.448C165.435 646.212 166.437 638.444 167.69 634.686Z" 
    fill={getFillByLot(15, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("16"))}    
    d="M254.132 647.217H212.79V599.61L254.132 598.357V647.217Z" 
    fill={getFillByLot(16, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("12"))}    
    d="M296.728 645.965L254.132 647.218V598.358L296.728 597.105V645.965Z" 
    fill={getFillByLot(12, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("13"))}    
    d="M269.166 548.242L229.076 549.495V599.607L269.166 598.354V548.242Z" 
    fill={getFillByLot(13, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("18"))}    
    d="M338.069 644.709L296.727 645.962V597.102L338.069 595.85V644.709Z" 
    fill={getFillByLot(18, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("19"))}    
    d="M379.411 643.457L338.069 644.71V595.85L379.411 594.598V643.457Z" 
    fill={getFillByLot(19, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("20"))}    
    d="M422.007 642.205L379.411 643.458V594.599L422.007 593.346V642.205Z" 
    fill={getFillByLot(20, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("12"))}    
    d="M308.004 546.996L269.167 548.249V598.361L308.004 597.108V546.996Z" 
    fill={getFillByLot(12, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("11"))}    
    d="M345.585 545.734L308.001 546.987V597.099L345.585 595.846V545.734Z" 
    fill={getFillByLot(11, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("10"))}    
    d="M384.425 543.607L345.588 545.738V595.851L384.425 594.599V543.607Z" 
    fill={getFillByLot(10, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("9"))}    
    d="M423.264 593.347V542.609L404.471 543.235L384.427 543.709V594.6L423.264 593.347Z" 
    fill={getFillByLot(9, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("8"))}    
    d="M462.098 540.727L423.261 542.407V593.345L462.098 592.092V540.727Z" 
    fill={getFillByLot(8, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("7"))}    
    d="M500.937 539.477L462.1 540.729V592.094L500.937 590.842V539.477Z" 
    fill={getFillByLot(7, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("21"))}    
    d="M463.352 640.949L422.009 642.202V593.343L463.352 592.09V640.949Z" 
    fill={getFillByLot(21, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("22"))}    
    d="M505.947 640.95H463.352V592.091L504.694 590.838L505.947 640.95Z" 
    fill={getFillByLot(22, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("23"))}    
    d="M547.288 639.7L505.946 640.953L504.693 590.841L546.035 589.588L547.288 639.7Z" 
    fill={getFillByLot(23, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("24"))}    
    d="M588.63 638.442L547.288 639.695L546.035 589.583L587.378 588.33L588.63 638.442Z" 
    fill={getFillByLot(24, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("6"))}    
    d="M539.772 538.623L500.935 539.473V590.839L539.772 589.586V538.623Z" 
    fill={getFillByLot(6, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("5"))}    
    d="M577.357 537.523L539.773 538.223V589.589L577.357 588.336V537.523Z" 
    fill={getFillByLot(5, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("4"))}    
    d="M616.192 536.967L577.355 537.35V588.332L616.192 587.079V536.967Z" 
    fill={getFillByLot(4, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("3"))}    
    d="M655.03 535.717L616.193 536.97V587.082L655.03 586.557V535.717Z" 
    fill={getFillByLot(3, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("25"))}    
    d="M631.227 637.194L588.631 638.447L587.378 588.335L631.227 587.082V637.194Z" 
    fill={getFillByLot(25, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("26"))}    
    d="M671.313 635.942L631.223 637.195V587.083L671.313 585.83V635.942Z" 
    fill={getFillByLot(26, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("27"))}    
    d="M712.661 635.36L671.319 635.939V585.827L712.661 585.102V635.36Z" 
    fill={getFillByLot(27, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("28"))}    
    d="M755.252 633.434L712.656 635.354V585.102L743.976 584.574L761.516 619.653C764.522 627.671 758.592 632.181 755.252 633.434Z" 
    fill={getFillByLot(28, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M722.682 538.22L743.979 584.574H693.867V533.209H712.659C718.673 533.209 721.847 536.55 722.682 538.22Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}    
    d="M655.028 535.715L693.865 533.209V585.827H655.028V535.715Z" 
    fill={getFillByLot(2, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <defs>
    <pattern id="pattern0_1465_19735" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1465_19735" transform="matrix(0.00171843 0 0 0.00227818 -2.89874 -1.76259)"/>
    </pattern>
    <image id="image0_1465_19735" width="4096" height="2304" href="/mz2.png"/>
  </defs>
</svg>

  );
};
